<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M10.78 18.19a.49.49 0 01-.35-.15.5.5 0 010-.71l5.46-5.46 5.46 5.46a.51.51 0 010 .71.5.5 0 01-.71 0l-4.75-4.75L11.14 18a.51.51 0 01-.36.19z"/><path d="M27 9v14H5V9h22m0-2H5a2 2 0 00-2 2v14a2 2 0 002 2h22a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M13.14 18.12l2.31-2.31a.65.65 0 01.91 0l2.3 2.31a.64.64 0 01-.45 1.09H13.6a.64.64 0 01-.46-1.09z"/></svg>